import { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { Button, DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'reactstrap';
import classnames from 'classnames';

import isEmpty from 'Lib/utilities/isEmpty';
import isFunction from 'Lib/utilities/isFunction';

/**
 * @deprecated This Page component is outdated, please import the Page from your portal.
 * e.g. /apps/manager/src/components/common/page-layout/index.js
 */
export class Page extends Component {
    render() {
        return <div className="page">{this.props.children}</div>;
    }
}

export class PageBody extends Component {
    render() {
        return <div className="page-body">{this.props.children}</div>;
    }
}

export class PageHeader extends Component {
    renderActions() {
        const { renderActions, actions, forceActionDropdown = false } = this.props;
        let action = null;

        if (isFunction(renderActions)) {
            return renderActions();
        }

        if (!actions) {
            return null;
        }

        let actionList = [];

        if (isFunction(actions)) {
            actionList = actions();
        } else {
            actionList = actions;
        }

        if (!actionList || isEmpty(actionList)) {
            return null;
        }

        if (actionList.length == 1 && forceActionDropdown === false) {
            action = actionList[0];
            const { color = 'primary' } = action;

            if (action.to) {
                const { to, ...rest } = action;

                return (
                    <Link to={to} {...rest}>
                        <Button color={color}>
                            {action.icon ? (
                                <Fragment>
                                    <i className={`${action.icon}`}></i>&nbsp;&nbsp;
                                </Fragment>
                            ) : null}
                            {action.label}
                        </Button>
                    </Link>
                );
            }

            if (action.onClick) {
                const { color = 'primary' } = action;

                return (
                    <Button onClick={action.onClick} color={color}>
                        {action.icon ? (
                            <Fragment>
                                <i className={`${action.icon}`}></i>&nbsp;&nbsp;
                            </Fragment>
                        ) : null}
                        {action.label}
                    </Button>
                );
            }
        } else {
            return (
                <UncontrolledDropdown>
                    <DropdownToggle caret color="primary">
                        Actions
                    </DropdownToggle>
                    <DropdownMenu>
                        {actionList.map((action, index) => {
                            if (action.to) {
                                const { to, ...rest } = action;

                                return (
                                    <DropdownItem key={index}>
                                        <Link to={to} {...rest}>
                                            {action.label}
                                        </Link>
                                    </DropdownItem>
                                );
                            }

                            if (action.onClick) {
                                return (
                                    <DropdownItem key={index} onClick={action.onClick}>
                                        {action.label}
                                    </DropdownItem>
                                );
                            }
                        })}
                    </DropdownMenu>
                </UncontrolledDropdown>
            );
        }
    }

    render() {
        return (
            <div className="page-header">
                <div className="page-header-title">
                    <h1>{this.props.title}</h1>
                </div>
                <div className="page-header-actions">{this.props.children ? this.props.children : this.renderActions()}</div>
            </div>
        );
    }
}

export class PageSidebar extends Component {
    state = {
        isClosed: false
    };

    toggle = () => {
        this.setState(state => ({
            isClosed: !state.isClosed
        }));
    };

    render() {
        return (
            <div className={classnames('page-sidebar', { closed: this.state.isClosed })}>
                <div className="page-sidebar-header" onClick={this.toggle}>
                    <span className="page-sidebar-header-icon">&#8810;</span>
                </div>
                <div className="page-sidebar-body">{this.props.children}</div>
            </div>
        );
    }
}

export class PageSidebarItem extends Component {
    state = {
        isClosed: true
    };

    toggle = () => {
        this.setState({
            isClosed: !this.state.isClosed
        });
    };

    render() {
        return (
            <div className={classnames('page-sidebar-item', { closed: this.state.isClosed })}>
                <div className="page-sidebar-item-header" onClick={this.toggle}>
                    <span className="page-sidebar-item-header-title">{this.props.title}</span>
                </div>
                <div className="page-sidebar-item-body">
                    <div className="page-sidebar-item-body-content">{this.props.children}</div>
                </div>
            </div>
        );
    }
}

export class PageNav extends Component {
    onClick = option => {
        if (option.onClick) {
            option.onClick(option.value);
        }
    };

    render() {
        const { current, styleoverride } = this.props;
        let { options } = this.props;

        if (!options) {
            return <></>;
        }

        if (isFunction(options)) {
            options = options();
        }

        if (!Array.isArray(options)) {
            return <></>;
        }

        return (
            <div className="page-nav" style={styleoverride ? styleoverride : {}}>
                <ul>
                    {options.map((option, index) => (
                        <li key={index} className={classnames({ active: current == option.value })} onClick={() => this.onClick(option)}>
                            {option.label}
                        </li>
                    ))}
                </ul>
            </div>
        );
    }
}
